export const GRIDGIO_PATH = {
  LANDING_PATH: '/gi',
  APP_PATH: '/gi/app',
  CHECKPOINT_PATH: '/gi/checkpoint',
  START_PATH: '/gi/start',
  INITIAL_SERVICE_PATH: '/gi/home/begin',
  // Service overview.
  HOME_PATH: '/gi/home/:home',
  HOME_BEGIN_PATH: '/gi/home/begin',
  // Project main menu.
  PROJECT_PATH: '/gi/project/:project',
  PROJECT_HOME_PATH: '/gi/project/home',
  PROJECT_ITEM_PATH: '/gi/project/:projectKey',
  PROJECT_PLAN_PATH: '/gi/project/:projectKey/plan',
  PROJECT_WORK_PATH: '/gi/project/work/:workKey',
  // Global source management.
  SOURCE_PATH: '/gi/source/:source',
  SOURCE_HOME_PATH: '/gi/source/home',
  LAB_HOME_PATH: '/gi/lab/home',
  // GridgIO settings: reserved until implemented.
  SETTING_PATH: '/gi/setting/:setting',
  SETTING_HOME_PATH: '/gi/setting/home',
} as const;

export const createProjectPath = (page: 'home' | 'project' | 'work' | 'plan' = 'home', key?: string) => {
  if (page === 'project' && key) return `/gi/project/${encodeURIComponent(key)}`;
  if (page === 'plan' && key) return `/gi/project/${encodeURIComponent(key)}/plan`;
  if (page === 'work' && key) return `/gi/project/work/${encodeURIComponent(key)}`;
  return GRIDGIO_PATH.PROJECT_HOME_PATH;
};

export const createSourcePath = (page: 'home' = 'home') => `/gi/source/${page}`;
